<template>
	<div
		:parent-validation="setup.isValid"
		:parent-display-validation="setup.displayValidationState"
		class="select-picto-card"
		@click.stop.prevent="setup.displayValidationState ? setup.displayValidationState = false : undefined">
		<shared-picto-card
			v-for="picto in options"
			:key="picto.id"
			tag="icon"
			selectable
			label
			:picto="picto"
			:selected="setup.isSelected(picto)"
			:error="(setup.displayValidationState && !setup.isValid)"
			@click="setup.selectItem(picto)"/>
	</div>
</template>

<script setup lang="ts">
// #region Setup
import type { SharedSelectPictoCardEmits, SharedSelectPictoCardProps } from './SharedSelectPictoCardSetup';
import SharedSelectPictoCardSetup from './SharedSelectPictoCardSetup';
const emits = defineEmits<SharedSelectPictoCardEmits>() as SharedSelectPictoCardEmits;
const props = withDefaults(defineProps<SharedSelectPictoCardProps>(), SharedSelectPictoCardSetup.defaultProps);
const setup = new SharedSelectPictoCardSetup(props, emits);
// #endregion
</script>

<style scoped lang="less">
.select-picto-card {
	display: grid;
	grid-template-columns: repeat(5, 4rem);
	gap: 1rem;

	> .picto-card {
		height: 100%;

		:deep(.orion-card__selected) {
			z-index: 1;
		}
	}
}
</style>
